export const PRIMARY_BUTTON_BLUE = '#0475DD';
export const DISABLED_BUTTON_GRAY = 'gray';
export const ONLINE_GREEN = '#00FF00';
export const OFFLINE_RED = '#FF0000';

export const TEXT_DARK_GRAY = '#3B3B3B';
export const ICON_DARK_GRAY = '#3B3B3B';

export const PRIMARY_COLOR = "#0475DD";

export const UNDERLINE_ACCENT_COLOR = "#0475DD";
export const UNDERLINE_DARK_COLOR = "#3B3B3B";

export const ICON_COLOR = "gray";
export const PREMIUM_ICON_COLOR = "#FFD700";

export const LIST_ITEM_BACKGROUND_COLOR = "#F7F7F7";

export const BACKGROUND_COLOR = "#F7F7F7";